let apiPromise;

function hasConsent() {
    return window.Cookiebot && window.Cookiebot.consent && window.Cookiebot.consent.marketing;
}

function loadPlayerApi() {
    if (window.YT && window.YT.Player) {
        return Promise.resolve(window.YT);
    }
    if (!apiPromise) {
        apiPromise = new Promise((resolve, reject) => {
            const previousReady = window.onYouTubeIframeAPIReady;
            window.onYouTubeIframeAPIReady = () => {
                resolve(window.YT);
                if (typeof previousReady === 'function') {
                    previousReady();
                }
            };
            const script = document.createElement('script');
            script.src = 'https://www.youtube.com/iframe_api';
            script.async = true;
            script.onerror = () => {
                apiPromise = null;
                script.remove();
                window.onYouTubeIframeAPIReady = previousReady;
                reject(new Error('YouTube player API could not be loaded'));
            };
            document.head.appendChild(script);
        });
    }
    return apiPromise;
}

export default function startYouTubePlayback(iframe) {
    if (!hasConsent()) {
        return;
    }
    loadPlayerApi().then(api => {
        if (!iframe.isConnected || !hasConsent()) {
            return;
        }
        new api.Player(iframe, {
            events: {
                onReady: event => {
                    if (iframe.isConnected && hasConsent()) {
                        event.target.unMute();
                        event.target.playVideo();
                    }
                },
                onAutoplayBlocked: () => {
                    iframe.dataset.autoplayBlocked = 'true';
                }
            }
        });
    }).catch(error => {
        console.warn('Unable to start YouTube playback', error);
    });
}
